<template>
  <div>
    <div class="div">
      <div>
        <el-button @click="$router.back()" size="small" class="spacebtn">返回</el-button>
        <el-button
          class="spacebtn"
          @click="add()"
          type="primary"
          size="small"
          v-if="$_has('v-add')"
        >+ 创建版本</el-button>
      </div>
      <div>
        <my-table hidden :tableData="tableData" :columns="version.tableColumns">
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                @click="edit(scope.row)"
                type="text"
                size="medium"
                v-if="$_has('v-edit')"
              >编辑</el-button>
              <!-- <el-button @click="detail(scope.row)" type="text" size="medium">详情</el-button> -->
              <el-button
                @click="closed(scope.row,7)"
                type="text"
                size="medium"
                :disabled="scope.row.stage == 7"
              >结束</el-button>
              <!-- <el-button @click="closed(scope.row,1)" v-if="scope.row.stage === 7" type="text" size="medium" >启用</el-button> -->
              <el-button
                @click="del(scope.row.id)"
                type="text"
                size="medium"
                v-if="$_has('v-edit')"
              >删除</el-button>
            </template>
          </el-table-column>
        </my-table>

        <tableBody
          :tableNameList="version.tableColumns"
          :tableData="tableData"
          :controller="tableController"
          :row-style="{height:'60px'}"
          :cell-style="{padding:'0px'}"
          :diyHeight="'calc(100vh - 200px)'"
        >
          <template slot="acceptanceCriteria" slot-scope="list">
            <el-popover placement="top-start" width="200" trigger="hover">
              <el-input
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 8}"
                readonly
                class="elInput"
                v-model="list.scope.row['acceptanceCriteria']"
              ></el-input>
              <div
                slot="reference"
                v-html="list.scope.row['acceptanceCriteria']"
                class="table-content"
              >{{list.scope.row['acceptanceCriteria']}}</div>
            </el-popover>
          </template>

          <template slot="costResource" slot-scope="list">
            <div>{{list.scope.row.costResource}}人天({{list.scope.row.costPercentage}}%)</div>
          </template>
          <template slot="laveResource" slot-scope="list">
            <div>{{list.scope.row.laveResource}}人天</div>
          </template>
          <template slot="finishedTestProgressRate" slot-scope="list">
            <div>{{list.scope.row.finishedTestProgressRate}}%</div>
          </template>

          <template slot="control" slot-scope="list">
            <el-button @click="edit(list.scope.row)" type="text" size="medium">编辑</el-button>
            <!-- <el-button @click="detail(list.scope.row)" type="text" size="medium">详情</el-button> -->
            <el-button
              @click="closed(list.scope.row,7)"
              type="text"
              size="medium"
              :disabled="list.scope.row.stage == 7"
            >结束</el-button>
            <!-- <el-button @click="closed(list.scope.row,1)" v-if="list.scope.row.stage === 7" type="text" size="medium" >启用</el-button> -->
            <el-button @click="del(list.scope.row.id)" type="text" size="medium">删除</el-button>
          </template>
        </tableBody>
      </div>
    </div>
    <pagination
      style="padding:0 20px"
      :pageSize="pagesize"
      :currentPage="currentPage"
      :pageTotal="pageTotal"
      @handleCurrentChange="handleCurrentChange"
    ></pagination>

    <dialog-panel
      :title="versionTitle"
      :dialogController="versionBoard"
      width="600px"
      :loading="btnLoading"
      @cancel="closeVersionBoard"
      @confirm="confirmVersionBoard"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="120px"
        size="medium"
        @submit.native.prevent="confirmVersionBoard"
      >
        <input type="hidden" :value="form.id" />
        <input type="hidden" :value="form.projectId" />
        <el-form-item label="版本号：" required>
          <el-input v-model="form.version" maxlength="16" show-word-limit placeholder="请输入版本号"></el-input>
        </el-form-item>
        <el-form-item label="验收标准：" required>
          <el-input
            v-model="form.acceptanceCriteria"
            type="textarea"
            :autosize="{ minRows: 5, maxRows: 8}"
            placeholder="请输入验收标准"
          ></el-input>
        </el-form-item>
        <el-form-item label="资源池(人天):" required>
          <el-input v-model="form.resourcePool" placeholder="填写项目预估资源投入"></el-input>
        </el-form-item>
        <el-form-item label="风险池(人天):" required>
          <el-input v-model="form.riskPool" placeholder="填写项目预估风险"></el-input>
        </el-form-item>
        <el-form-item label="选择岗位角色:" required>
          <el-checkbox-group v-model="jobList" @change="handleCheckedCitiesChange">
            <el-checkbox
              v-for="(rol, index) in selectOptions.jobOptions"
              :key="index"
              :label="rol.id"
              size="small"
            >{{rol.name}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </dialog-panel>
  </div>
</template>

<script>
import { updateVersion, addVersion, removeVersionById, getCompanyDictByCode, getVersionPage, getVersionDetail, updateVersionStage, getStatisticsProjectVersionPartData } from "./versionAPI"
import { Version } from "../projectDTO";
import * as _ from "utils/validate";
import { uuid } from "utils/handle";

let actionType = 'add'

export default {
  data () {
    return {
      tableData: [],
      version: Version,
      versionTitle: '新增版本',
      versionBoard: false,
      form: {},
      jobList: [],
      selectOptions: {
        jobOptions: [],
      },
      textarea2: '',
      btnLoading: false,
      tableController: {
        isActive: true,
        selection: false,
        index: true,
        width: 180,
        rowKey: ''
      },
      pagesize: 10,
      currentPage: 1,
      pageTotal: 1,
    }
  },
  methods: {
    handleCheckedCitiesChange (value) {
      console.log('点击', value)
      // let checkedCount = value.length;
      // this.checkAll = checkedCount === this.cities.length;
      // this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    closeVersionBoard () { // 关闭
      this.versionBoard = false
    },
    confirmVersionBoard () {  // 提交
      let f = {
        ...this.form
      };
      if (_.validNString(f.version)) {
        this.$message.error("版本号是必填的");
        return;
      }
      if (_.validNString(f.acceptanceCriteria)) {
        this.$message.error("验收标准是必填的");
        return;
      }
      if (_.validNString(String(f.resourcePool))) {
        this.$message.error("资源池是必填的");
        return;
      }
      if (_.validNString(String(f.riskPool))) {
        this.$message.error("风险池是必填的");
        return;
      }
      if (_.validNum(f.resourcePool)) {
        this.$message.error("资源池(人天)只允许数字");
        return;
      }
      if (_.validNum(f.riskPool)) {
        this.$message.error("风险池(人天)只允许数字");
        return;
      }

      if (this.actionType === 'edit') {
        f.jobList = this.jobList
        this.btnLoading = true
        updateVersion(f).then(res => { // 更新
          if (res.code === 1000) {
            this.$message.success(`修改成功`);
            this.funGetVersionByProjectId()
            this.closeVersionBoard();
          } else {
            this.btnLoading = false
          }
        }).catch(err => {
          this.closeVersionBoard();
        }).finally(() => {
          this.btnLoading = false
        });
      } else if (this.actionType === 'add') {
        f.jobList = this.jobList
        this.btnLoading = true
        addVersion(f).then(res => {
          if (res.code === 1000) {
            this.$message.success(`添加成功`);
            this.funGetVersionByProjectId()
            this.closeVersionBoard();
            this.btnLoading = false
          }
        }).finally(() => {
          this.btnLoading = false
        })
      }
    },
    add () { // 新增版本
      this.jobList = []
      this.actionType = 'add'
      this.versionBoard = true
      this.form = new Version()
      this.form.id = uuid

      this.selectOptions.jobOptions.forEach(item => {
        // if (item.name === '测试') {
        //   this.jobList.push(item.id) // 默认选中测试
        // }
         if (item.code === 'TEST') {
          this.jobList.push(item.id) // 默认选中测试
        }
      });

      this.form.projectId = this.$route.query.projectId
      this.dictItemBoardTitle = `新增版本`;
    },
    edit (obj) {
      this.actionType = 'edit'
      this.versionBoard = true
      this.versionTitle = '编辑版本'
      // this.jobList = obj.jobList
      this.form = obj
      getVersionDetail(obj.id).then(res => {
        if (res.data.projectVersionJobList) {
          this.jobList = res.data.projectVersionJobList
        }
        else {
          this.jobList = []
        }
        // this.jobList = ress.data.projectVersionJobVOList.map(item => item.id);
      })
    },
    del (id) {
      this.$confirm('确定删除此版本？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        removeVersionById(id).then(res => {
          if (res.code === 1000) {
            this.$message.success(`删除成功`);
            this.funGetVersionByProjectId()
            this.closeDictBoard();
          }
        })
      }).catch(() => {
        // this.$message({ type: 'info', message: '已取消删除' })
      })
    },
    detail (e) {
      this.$router.push({ path: '/project-manage/demand-manage/list', query: { projectVersionId: e.id } })
    },
    closed (obj, stage) {
      this.$confirm(`确定${stage !== 7 ? "启用" : "结束"}此版本？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form = obj
        let f = {
          ...this.form
        };
        f.stage = stage // 项目关闭
        updateVersionStage({ id: f.id, stage: stage }).then(res => {// 更新
          if (res.code === 1000) {
            this.$message.success(`操作成功`);
            this.funGetVersionByProjectId()
          }
        })
      })
    },
    handleCurrentChange (v) {
      this.currentPage = v
      this.funGetVersionByProjectId()
    },
    funGetVersionByProjectId () {
      let para = {
        current: this.currentPage,
        projectId: this.$route.query.projectId,
        size: this.pagesize
      }
      getVersionPage(para).then(res => {
        if (res.code === 1000) {
          this.tableData = res.data.records
          this.pageTotal = res.data.total
          this._getPool({
            projectVersionIdList:this.tableData.map(i=>i.id).join(',')
          })
        }
      }).catch(err => {
      })
    },
    _getPool(params){
      getStatisticsProjectVersionPartData(params).then(res=>{
        let obj = res.data
        this.tableData.forEach(item=>{
          this.$set(item,'costResource',obj[item.id].costResource)
          this.$set(item,'laveResource',obj[item.id].laveResource)
          this.$set(item,'finishedTestProgressRate',obj[item.id].finishedTestProgressRate)
          this.$set(item,'progressWarningType',obj[item.id].progressWarningType)
          this.$set(item,'costPercentage',obj[item.id].costPercentage)
        })
      })
    },
    funGetCompanyDictByCode () {
      // DEMAND_JOB
      getCompanyDictByCode({ dictGroupCode: "PROJECT_JOB" }).then(res => {
        this.selectOptions.jobOptions = res.data.records
      })
    }
  },
  mounted () {
    this.funGetVersionByProjectId()
    this.funGetCompanyDictByCode()
  },
  // created () {

  // },
  watch: {
    // 方法一
    //在watch中监听路由变化，其中$route.query.projectId，projectId代表页面间传递的参数，funGetVersionByProjectId代表调用的方法
    // "$route.query.projectId": "funGetVersionByProjectId"
    // 方法二
    // '$route' (to, from) {
    // console.log('isd',this.$route.query.projectId)
    //   if(this.$route.query.projectId){ // 返回的时候也会触发 要进行非空判断
    //     this.funGetVersionByProjectId()
    //   }
    // },
    // 方法三
    // 在 router-view 中加 :key="$route.fullPath"
  }
}
</script>

<style scoped>
.elInput >>> textarea {
  margin-top: 20px;
  outline: none;
  /* overflow: auto; */
  /* height: auto; */
  /* border: none; */
  /* border: 0 none; */
  border: 1px solid #fff !important;
  padding: 0;
  resize: none;
}
.div {
  margin: 20px;
  width: 95%;
}
.header {
  height: 30px;
  background-color: #dcdee2;
  line-height: 30px;
  border: 0.5px solid #e8eaec;
  text-align: left;
  /* 缩进2个字节 */
  text-indent: 2em;
}
.table-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.flotleft {
  float: left;
}
.outDiv {
  margin-left: 70px;
}
.divs {
  text-align: left;
  margin-left: 40px;
  margin-bottom: 15px;
}
.spacebtn {
  margin-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/project-manage/version/list.vue